import React, { useEffect } from 'react';
import {
	Button,
	OrderList,
} from '../../components/StyledComponents';
import { Page } from '../../components/ui/Page'
import Store from '../../store/Store';
import { Body } from '../../components/layout/Body';

export interface DashboardPageProviderProps {
	id?: string;
}

export default function DashboardPageProvider(props: DashboardPageProviderProps) {
	const [, orders] = Store.use('ordersError', 'orders') as [
		unknown,
		Array<{ orderState: string; [key: string]: unknown }>,
	];

	useEffect(() => {
		if (!orders?.length) Store.loadOrders();
	}, []);

	const orderList = Array.isArray(orders) ? orders : [];

	return (
		<>
			<Page>
				<Body id={props.id}>

					<OrderList
						title="Alle Aufträge"
						orders={orderList as Parameters<typeof OrderList>[0]['orders']}
					/>
				</Body>
			</Page>
		</>
	);
}
